// store.js
import { configureStore } from "@reduxjs/toolkit";
import apiReducer from "./apiReducer";

// Create Redux store
const store = configureStore({
  reducer: {
    api: apiReducer,  // Attach your API reducer
  },
});

export default store;
